

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Location } from 'vue-router';
import LocationContract from '@/location/LocationContract';
import LocationNavItem from '@/components/header/LocationNavItem.vue';
import NavItem from '@/components/header/NavItem.vue';

@Component({
    components: {
        NavItem,
        LocationNavItem,
    },
})
export default class Mainnav extends Vue {
    @Prop({ type: Array, required: false, default: () => [] })
    private locations!: Array<LocationContract>;

    private get overviewActiveImage(): string {
        return require('@/assets/images/overview-active.png');
    }

    private get overviewInactiveImage(): string {
        return require('@/assets/images/overview-inactive.png');
    }

    private get homepageUrl(): Location {
        return {
            name: 'home',
            params: {
                locale: this.$route.params.locale,
            },
        };
    }
}
